import { useEffect, useMemo, useState } from 'react';
import axiosInstance from '../../../axiosInstance';
import {
  buildDashboardDateQueryParams,
  dashboardDateFilterKey,
} from '../../../utils/dashboardDateRangeUtils';

const EMPTY_KPIS = {
  activeTasks: 0,
  closedTasks: 0,
  newRequests: 0,
  rejectedRequests: 0,
};

/**
 * @param {'admin' | 'super-admin' | 'enduser'} persona
 * @param {{ preset: string, customRange: any }} dateFilter
 */
export function useHomeDashboard(persona, dateFilter) {
  const [kpis, setKpis] = useState(EMPTY_KPIS);
  const [statusBarData, setStatusBarData] = useState([]);
  const [priorityBarData, setPriorityBarData] = useState([]);
  const [slaAtRiskRows, setSlaAtRiskRows] = useState([]);
  const [showPaymentCharts, setShowPaymentCharts] = useState(false);
  const [loading, setLoading] = useState(true);
  const dateFilterKey = useMemo(
    () => dashboardDateFilterKey(dateFilter),
    [dateFilter]
  );

  useEffect(() => {
    const isCustomer = persona === 'enduser';
    const url = isCustomer
      ? '/api/dashboard/home-summary/enduser'
      : '/api/dashboard/home-summary';

    let cancelled = false;
    setLoading(true);

    const params = buildDashboardDateQueryParams(dateFilter);

    axiosInstance
      .get(url, { params, withCredentials: true })
      .then((res) => {
        if (cancelled) return;
        setKpis({ ...EMPTY_KPIS, ...(res.data?.kpis || {}) });
        setStatusBarData(
          Array.isArray(res.data?.statusBarData) ? res.data.statusBarData : []
        );
        setPriorityBarData(
          Array.isArray(res.data?.priorityBarData)
            ? res.data.priorityBarData
            : []
        );
        setSlaAtRiskRows(
          Array.isArray(res.data?.slaAtRiskRows) ? res.data.slaAtRiskRows : []
        );
        setShowPaymentCharts(res.data?.showPaymentCharts === true);
      })
      .catch(() => {
        if (cancelled) return;
        setKpis(EMPTY_KPIS);
        setStatusBarData([]);
        setPriorityBarData([]);
        setSlaAtRiskRows([]);
        setShowPaymentCharts(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [persona, dateFilterKey, dateFilter]);

  return {
    kpis,
    statusBarData,
    priorityBarData,
    slaAtRiskRows,
    showPaymentCharts,
    loading,
  };
}
